export default {
  Region: 'us-west-2',
  UserPoolId: 'us-west-2_OnrXmvidK',
  ClientId: '1jp28doh2eu5t1j38io9braja',
  IdentityPoolId: 'us-west-2:fada5186-3c8d-4f25-af40-16e9d4b8039b',
  CognitoDomain:"aeru-webservice",
  CognitoAppClientID: "1jp28doh2eu5t1j38io9braja" ,
  RedirectURI: "http://localhost:8090/callback",
}

